import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { localize } from '../../../nls.js';
import { PickerQuickAccessProvider } from './pickerQuickAccess.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { or, matchesPrefix, matchesWords, matchesContiguousSubString } from '../../../base/common/filters.js';
import { withNullAsUndefined } from '../../../base/common/types.js';
import { LRUCache } from '../../../base/common/map.js';
import { IStorageService } from '../../storage/common/storage.js';
import { IConfigurationService } from '../../configuration/common/configuration.js';
import { IInstantiationService } from '../../instantiation/common/instantiation.js';
import { IKeybindingService } from '../../keybinding/common/keybinding.js';
import { ICommandService } from '../../commands/common/commands.js';
import { ITelemetryService } from '../../telemetry/common/telemetry.js';
import { isPromiseCanceledError } from '../../../base/common/errors.js';
import { INotificationService } from '../../notification/common/notification.js';
import { toErrorMessage } from '../../../base/common/errorMessage.js';
import { IStorageKeysSyncRegistryService } from '../../userDataSync/common/storageKeys.js';

var AbstractCommandsQuickAccessProvider = /*#__PURE__*/function (_PickerQuickAccessPro) {
  _inherits(AbstractCommandsQuickAccessProvider, _PickerQuickAccessPro);

  var _super = _createSuper(AbstractCommandsQuickAccessProvider);

  function AbstractCommandsQuickAccessProvider(options, instantiationService, keybindingService, commandService, telemetryService, notificationService) {
    var _this;

    _classCallCheck(this, AbstractCommandsQuickAccessProvider);

    _this = _super.call(this, AbstractCommandsQuickAccessProvider.PREFIX, options);
    _this.options = options;
    _this.instantiationService = instantiationService;
    _this.keybindingService = keybindingService;
    _this.commandService = commandService;
    _this.telemetryService = telemetryService;
    _this.notificationService = notificationService;
    _this.commandsHistory = _this._register(_this.instantiationService.createInstance(CommandsHistory));
    return _this;
  }

  _createClass(AbstractCommandsQuickAccessProvider, [{
    key: "getPicks",
    value: function getPicks(filter, disposables, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var allCommandPicks, filteredCommandPicks, _iterator, _step, _commandPick, labelHighlights, aliasHighlights, mapLabelToCommand, _i, _filteredCommandPicks, commandPick, existingCommandForLabel, commandPicks, addSeparator, _loop, i;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getCommandPicks(disposables, token);

              case 2:
                allCommandPicks = _context2.sent;

                if (!token.isCancellationRequested) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", []);

              case 5:
                // Filter
                filteredCommandPicks = [];
                _iterator = _createForOfIteratorHelper(allCommandPicks);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _commandPick = _step.value;
                    labelHighlights = withNullAsUndefined(AbstractCommandsQuickAccessProvider.WORD_FILTER(filter, _commandPick.label));
                    aliasHighlights = _commandPick.commandAlias ? withNullAsUndefined(AbstractCommandsQuickAccessProvider.WORD_FILTER(filter, _commandPick.commandAlias)) : undefined; // Add if matching in label or alias

                    if (labelHighlights || aliasHighlights) {
                      _commandPick.highlights = {
                        label: labelHighlights,
                        detail: this.options.showAlias ? aliasHighlights : undefined
                      };
                      filteredCommandPicks.push(_commandPick);
                    } // Also add if we have a 100% command ID match
                    else if (filter === _commandPick.commandId) {
                      filteredCommandPicks.push(_commandPick);
                    }
                  } // Add description to commands that have duplicate labels

                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                mapLabelToCommand = new Map();

                for (_i = 0, _filteredCommandPicks = filteredCommandPicks; _i < _filteredCommandPicks.length; _i++) {
                  commandPick = _filteredCommandPicks[_i];
                  existingCommandForLabel = mapLabelToCommand.get(commandPick.label);

                  if (existingCommandForLabel) {
                    commandPick.description = commandPick.commandId;
                    existingCommandForLabel.description = existingCommandForLabel.commandId;
                  } else {
                    mapLabelToCommand.set(commandPick.label, commandPick);
                  }
                } // Sort by MRU order and fallback to name otherwise


                filteredCommandPicks.sort(function (commandPickA, commandPickB) {
                  var commandACounter = _this2.commandsHistory.peek(commandPickA.commandId);

                  var commandBCounter = _this2.commandsHistory.peek(commandPickB.commandId);

                  if (commandACounter && commandBCounter) {
                    return commandACounter > commandBCounter ? -1 : 1; // use more recently used command before older
                  }

                  if (commandACounter) {
                    return -1; // first command was used, so it wins over the non used one
                  }

                  if (commandBCounter) {
                    return 1; // other command was used so it wins over the command
                  } // both commands were never used, so we sort by name


                  return commandPickA.label.localeCompare(commandPickB.label);
                });
                commandPicks = [];
                addSeparator = false;

                _loop = function _loop(i) {
                  var commandPick = filteredCommandPicks[i];

                  var keybinding = _this2.keybindingService.lookupKeybinding(commandPick.commandId);

                  var ariaLabel = keybinding ? localize('commandPickAriaLabelWithKeybinding', "{0}, {1}", commandPick.label, keybinding.getAriaLabel()) : commandPick.label; // Separator: recently used

                  if (i === 0 && _this2.commandsHistory.peek(commandPick.commandId)) {
                    commandPicks.push({
                      type: 'separator',
                      label: localize('recentlyUsed', "recently used")
                    });
                    addSeparator = true;
                  } // Separator: other commands


                  if (i !== 0 && addSeparator && !_this2.commandsHistory.peek(commandPick.commandId)) {
                    commandPicks.push({
                      type: 'separator',
                      label: localize('morecCommands', "other commands")
                    });
                    addSeparator = false; // only once
                  } // Command


                  commandPicks.push(Object.assign(Object.assign({}, commandPick), {
                    ariaLabel: ariaLabel,
                    detail: _this2.options.showAlias && commandPick.commandAlias !== commandPick.label ? commandPick.commandAlias : undefined,
                    keybinding: keybinding,
                    accept: function accept() {
                      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                // Add to history
                                this.commandsHistory.push(commandPick.commandId); // Telementry

                                this.telemetryService.publicLog2('workbenchActionExecuted', {
                                  id: commandPick.commandId,
                                  from: 'quick open'
                                }); // Run

                                _context.prev = 2;
                                _context.next = 5;
                                return this.commandService.executeCommand(commandPick.commandId);

                              case 5:
                                _context.next = 10;
                                break;

                              case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](2);

                                if (!isPromiseCanceledError(_context.t0)) {
                                  this.notificationService.error(localize('canNotRun', "Command '{0}' resulted in an error ({1})", commandPick.label, toErrorMessage(_context.t0)));
                                }

                              case 10:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, this, [[2, 7]]);
                      }));
                    }
                  }));
                };

                for (i = 0; i < filteredCommandPicks.length; i++) {
                  _loop(i);
                }

                return _context2.abrupt("return", commandPicks);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return AbstractCommandsQuickAccessProvider;
}(PickerQuickAccessProvider);

AbstractCommandsQuickAccessProvider.PREFIX = '>';
AbstractCommandsQuickAccessProvider.WORD_FILTER = or(matchesPrefix, matchesWords, matchesContiguousSubString);
AbstractCommandsQuickAccessProvider = __decorate([__param(1, IInstantiationService), __param(2, IKeybindingService), __param(3, ICommandService), __param(4, ITelemetryService), __param(5, INotificationService)], AbstractCommandsQuickAccessProvider);
export { AbstractCommandsQuickAccessProvider };

var CommandsHistory = /*#__PURE__*/function (_Disposable) {
  _inherits(CommandsHistory, _Disposable);

  var _super2 = _createSuper(CommandsHistory);

  function CommandsHistory(storageService, configurationService, storageKeysSyncRegistryService) {
    var _this3;

    _classCallCheck(this, CommandsHistory);

    _this3 = _super2.call(this);
    _this3.storageService = storageService;
    _this3.configurationService = configurationService;
    _this3.configuredCommandsHistoryLength = 0; // opt-in to syncing

    storageKeysSyncRegistryService.registerStorageKey({
      key: CommandsHistory.PREF_KEY_CACHE,
      version: 1
    });
    storageKeysSyncRegistryService.registerStorageKey({
      key: CommandsHistory.PREF_KEY_COUNTER,
      version: 1
    });

    _this3.updateConfiguration();

    _this3.load();

    _this3.registerListeners();

    return _this3;
  }

  _createClass(CommandsHistory, [{
    key: "registerListeners",
    value: function registerListeners() {
      var _this4 = this;

      this._register(this.configurationService.onDidChangeConfiguration(function () {
        return _this4.updateConfiguration();
      }));
    }
  }, {
    key: "updateConfiguration",
    value: function updateConfiguration() {
      this.configuredCommandsHistoryLength = CommandsHistory.getConfiguredCommandHistoryLength(this.configurationService);

      if (CommandsHistory.cache && CommandsHistory.cache.limit !== this.configuredCommandsHistoryLength) {
        CommandsHistory.cache.limit = this.configuredCommandsHistoryLength;
        CommandsHistory.saveState(this.storageService);
      }
    }
  }, {
    key: "load",
    value: function load() {
      var raw = this.storageService.get(CommandsHistory.PREF_KEY_CACHE, 0
      /* GLOBAL */
      );
      var serializedCache;

      if (raw) {
        try {
          serializedCache = JSON.parse(raw);
        } catch (error) {// invalid data
        }
      }

      var cache = CommandsHistory.cache = new LRUCache(this.configuredCommandsHistoryLength, 1);

      if (serializedCache) {
        var entries;

        if (serializedCache.usesLRU) {
          entries = serializedCache.entries;
        } else {
          entries = serializedCache.entries.sort(function (a, b) {
            return a.value - b.value;
          });
        }

        entries.forEach(function (entry) {
          return cache.set(entry.key, entry.value);
        });
      }

      CommandsHistory.counter = this.storageService.getNumber(CommandsHistory.PREF_KEY_COUNTER, 0
      /* GLOBAL */
      , CommandsHistory.counter);
    }
  }, {
    key: "push",
    value: function push(commandId) {
      if (!CommandsHistory.cache) {
        return;
      }

      CommandsHistory.cache.set(commandId, CommandsHistory.counter++); // set counter to command

      CommandsHistory.saveState(this.storageService);
    }
  }, {
    key: "peek",
    value: function peek(commandId) {
      var _a;

      return (_a = CommandsHistory.cache) === null || _a === void 0 ? void 0 : _a.peek(commandId);
    }
  }], [{
    key: "saveState",
    value: function saveState(storageService) {
      if (!CommandsHistory.cache) {
        return;
      }

      var serializedCache = {
        usesLRU: true,
        entries: []
      };
      CommandsHistory.cache.forEach(function (value, key) {
        return serializedCache.entries.push({
          key: key,
          value: value
        });
      });
      storageService.store(CommandsHistory.PREF_KEY_CACHE, JSON.stringify(serializedCache), 0
      /* GLOBAL */
      );
      storageService.store(CommandsHistory.PREF_KEY_COUNTER, CommandsHistory.counter, 0
      /* GLOBAL */
      );
    }
  }, {
    key: "getConfiguredCommandHistoryLength",
    value: function getConfiguredCommandHistoryLength(configurationService) {
      var _a, _b;

      var config = configurationService.getValue();
      var configuredCommandHistoryLength = (_b = (_a = config.workbench) === null || _a === void 0 ? void 0 : _a.commandPalette) === null || _b === void 0 ? void 0 : _b.history;

      if (typeof configuredCommandHistoryLength === 'number') {
        return configuredCommandHistoryLength;
      }

      return CommandsHistory.DEFAULT_COMMANDS_HISTORY_LENGTH;
    }
  }]);

  return CommandsHistory;
}(Disposable);

CommandsHistory.DEFAULT_COMMANDS_HISTORY_LENGTH = 50;
CommandsHistory.PREF_KEY_CACHE = 'commandPalette.mru.cache';
CommandsHistory.PREF_KEY_COUNTER = 'commandPalette.mru.counter';
CommandsHistory.counter = 1;
CommandsHistory = __decorate([__param(0, IStorageService), __param(1, IConfigurationService), __param(2, IStorageKeysSyncRegistryService)], CommandsHistory);
export { CommandsHistory };